/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */

/**
 * Shared constants / helpers for the Clinical Record panel.
 * Extracted from ClinicalRecordPanel.jsx (Code Quality refactor).
 */

export const SOAP_FIELDS = [
  { key: 'subjective', letter: 'S', label: 'Soggettivo', hint: 'Sintomi riferiti, anamnesi', color: 'text-sky-700 dark:text-sky-300 bg-sky-500/10 border-sky-500/30' },
  { key: 'objective', letter: 'O', label: 'Obiettivo', hint: 'Esame obiettivo, parametri', color: 'text-emerald-700 dark:text-emerald-300 bg-emerald-500/10 border-emerald-500/30' },
  { key: 'assessment', letter: 'A', label: 'Valutazione', hint: 'Ipotesi diagnostica', color: 'text-amber-700 dark:text-amber-300 bg-amber-500/10 border-amber-500/30' },
  { key: 'plan', letter: 'P', label: 'Piano', hint: 'Terapia, esami, follow-up', color: 'text-violet-700 dark:text-violet-300 bg-violet-500/10 border-violet-500/30' },
];

export const URGENCY_META = {
  routine: { cls: 'badge-online', label: 'urgencyRoutine' },
  urgent: { cls: 'badge-waiting', label: 'urgencyUrgent' },
  emergency: { cls: 'badge-emergency', label: 'urgencyEmergency' },
};

export const emptySoap = () => ({ subjective: '', objective: '', assessment: '', plan: '' });

export const formatSoapText = (s = {}) => [
  s.subjective && `S: ${s.subjective}`,
  s.objective && `O: ${s.objective}`,
  s.assessment && `A: ${s.assessment}`,
  s.plan && `P: ${s.plan}`,
].filter(Boolean).join('\n');
